(function(){
  'use strict';
  
  function init() {
    const root = document.querySelector('.home_banner_container');
    if (!root) return;

    const el = root.querySelector('[data-sold-number]');
    if (!el) return;

    el.textContent = String(Math.floor(Math.random() * 21) + 90);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();